export const host =
  process.env.NODE_ENV !== "production"
    ? "http://localhost:8080/api/result"
    : "https://eco.cyme.info/api/result";
